export default "__VITE_ASSET__8tIiWDrd__"